import { render, staticRenderFns } from "./public_gamescores.vue?vue&type=template&id=2705da4c&scoped=true"
import script from "./public_gamescores.vue?vue&type=script&lang=js"
export * from "./public_gamescores.vue?vue&type=script&lang=js"
import style0 from "./public_gamescores.vue?vue&type=style&index=0&id=2705da4c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2705da4c",
  null
  
)

export default component.exports